import { UsersIcon } from "@heroicons/react/outline";
import { useTranslation } from "@refinedev/core";
import Input from "components/input";
import { IBuildEventPageForm, TicketPlatform } from "interfaces";
import { Controller, useFormContext } from "react-hook-form";
import { twMerge } from "tailwind-merge";
import { SELECT_TICKET_PLATFORMS } from "utills/constants";

export const SelectTicketingPlatform = () => {
  const { translate } = useTranslation();
  const {
    getValues,
    control,
    formState: { errors },
  } = useFormContext<IBuildEventPageForm>(); // retrieve all hook methods
  console.log(getValues("platforms"))
  return (
    <div className={twMerge("py-4 px-4 sm:px-6 bg-magnolia-600 border rounded-lg", errors["platforms"] ? "border-red-500" : "border-brand-500")}>
      <div className="flex flex-col gap-4 xl:flex-row xl:justify-between">
        <div className="flex-1">
          <p className="font-bold">Select ticketing platform</p>
          <p className="text-gray-700 text-sm">
            Event information fields below will change based on the selected
            ticketing platform (used to publish the event and sell tickets).
            Organizer can select both ticketing platforms.
          </p>
        </div>
        <div className="flex-1 flex justify-end">
          <Controller
            control={control}
            name="platforms"
            defaultValue={[]}
            render={({ field: { onChange, value = [], ref } }) => (
              <div className="w-full flex flex-col sm:flex-row gap-4 xl:w-[600px]">
                {SELECT_TICKET_PLATFORMS.map((platform, index) => (
                  <div
                    className="flex-1 max-w-full rounded-lg border-solid border-[1px] bg-white border-gray-300 flex flex-col gap-y-2.5 px-4 py-4 sm:px-6"
                    key={index}
                  >
                    <div className="flex-1 flex items-start justify-between">
                      {platform.value === TicketPlatform.ACTIUP ? (
                        <img
                          src="/images/logo/colored.png"
                          className="w-20"
                          alt="Actiup Logo"
                        />
                      ) : (
                        <UsersIcon className="size-7 text-brand-500" />
                      )}
                      <Input
                        type="checkbox"
                        checked={value.includes(platform.value)}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const isChecked = e.target.checked;
                          const updatedValue = [...value];
                          if (isChecked) {
                            updatedValue.push(platform.value);
                          } else {
                            updatedValue.splice(
                              updatedValue.indexOf(platform.value),
                              1
                            );
                          }
                          onChange(updatedValue);
                        }}
                      />
                    </div>
                    <p className="text-sm">{platform.label}</p>
                  </div>
                ))}
              </div>
            )}
          />
        </div>
      </div>
      {errors["platforms"] ? (
        <p className="error-text">
          <span className="font-medium">{errors["platforms"].message}</span>
        </p>
      ) : null}
    </div>
  );
};
